document.addEventListener('DOMContentLoaded', function () {
  /* Mobile nav */
  var burger = document.getElementById('burgerBtn');
  var panel = document.getElementById('mobilePanel');
  if (burger && panel) {
    burger.addEventListener('click', function () {
      panel.classList.toggle('open');
    });
    panel.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') panel.classList.remove('open');
    });
  }

  /* Search flyout */
  var searchBtn = document.getElementById('searchBtn');
  var searchFlyout = document.getElementById('searchFlyout');
  if (searchBtn && searchFlyout) {
    searchBtn.addEventListener('click', function () {
      searchFlyout.classList.toggle('open');
      if (searchFlyout.classList.contains('open')) {
        var input = searchFlyout.querySelector('input');
        if (input) input.focus();
      }
    });
  }

  /* Newsletter form (theme preview only; real store should point to Shopify's
     customer/contact endpoint via form action in the section markup) */
  var nlForm = document.getElementById('nlForm');
  if (nlForm) {
    nlForm.addEventListener('submit', function (e) {
      if (nlForm.getAttribute('action')) return; // let real Shopify form submit
      e.preventDefault();
      var email = document.getElementById('nlEmail').value;
      var msgWrap = document.getElementById('nlMsgWrap');
      var msg = document.getElementById('nlMsg');
      if (msg) msg.textContent = "You're in — confirmation on the way to " + email + ".";
      if (msgWrap) msgWrap.style.display = 'block';
      nlForm.reset();
    });
  }

  /* Accordion (product page: description / size guide / shipping) */
  document.querySelectorAll('.acc-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.acc-item');
      var wasOpen = item.classList.contains('open');
      item.parentElement.querySelectorAll('.acc-item').forEach(function (el) {
        el.classList.remove('open');
        el.querySelector('.acc-trigger').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* "Size guide" link under the size swatches: opens + scrolls to that accordion panel */
  document.querySelectorAll('[data-acc-open]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById(link.dataset.accOpen);
      if (!target) return;
      target.parentElement.querySelectorAll('.acc-item').forEach(function (el) {
        el.classList.remove('open');
        el.querySelector('.acc-trigger').setAttribute('aria-expanded', 'false');
      });
      target.classList.add('open');
      target.querySelector('.acc-trigger').setAttribute('aria-expanded', 'true');
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* Product gallery thumbnails */
  document.querySelectorAll('.product-gallery').forEach(function (gallery) {
    var mainImg = gallery.querySelector('.main-image img');
    gallery.querySelectorAll('.product-thumbs button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        gallery.querySelectorAll('.product-thumbs button').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (mainImg && btn.dataset.full) mainImg.src = btn.dataset.full;
      });
    });
  });

  /* Variant option swatches -> hidden select + price/availability swap */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantsJson = form.querySelector('[data-variants-json]');
    var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    var optionInputs = form.querySelectorAll('[data-option-index]');
    var variantIdInput = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var compareEl = form.querySelector('[data-compare-price]');
    var stockEl = form.querySelector('[data-stock]');
    var addBtn = form.querySelector('[data-add-to-cart]');

    function currentSelection() {
      var sel = [];
      optionInputs.forEach(function (group) {
        var active = group.querySelector('.swatch.active');
        sel.push(active ? active.dataset.value : null);
      });
      return sel;
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function sync() {
      var sel = currentSelection();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
      if (!match) return;
      if (variantIdInput) variantIdInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (stockEl) {
        stockEl.classList.toggle('in', match.available);
        stockEl.classList.toggle('out', !match.available);
        stockEl.textContent = match.available ? 'In stock, ready to ship' : 'Out of stock';
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.dataset.addLabel : addBtn.dataset.soldOutLabel;
      }
      var stickyPrice = document.querySelector('[data-price-mirror]');
      if (stickyPrice) stickyPrice.textContent = money(match.price);
      var stickyBtn = document.getElementById('stickyAddToCart');
      if (stickyBtn) stickyBtn.disabled = !match.available;
    }

    form.querySelectorAll('.swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.disabled) return;
        var group = swatch.closest('[data-option-index]');
        group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');
        sync();
      });
    });
    sync();
  });

  /* Sticky mobile add-to-cart bar: shows once the real Add to Cart button
     has scrolled out of view above the fold, so the action is always reachable. */
  var stickyAtc = document.getElementById('stickyAtc');
  var mainAddToCart = document.getElementById('mainAddToCart');
  if (stickyAtc && mainAddToCart && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      stickyAtc.classList.toggle('visible', entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, { threshold: 0 });
    observer.observe(mainAddToCart);

    var stickyBtn = document.getElementById('stickyAddToCart');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        mainAddToCart.click();
      });
    }
  }

  /* Quantity steppers */
  document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    stepper.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.step === 'down' ? -1 : 1;
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
});
